import React, { Fragment } from 'react';

import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import './TestDetails.scss';

export class TestDetails extends React.Component<any, any> {

  constructor(props: any) {
    super(props);

    this.state = {
      // actions: [],
      // application: null,
      showPanel: props.showTest
    };

    // const { match: { params } } = this.props;

    console.log(props.showTest);
  }

  render() {
    return (
      <Fragment>
        <div>abc</div>
        <this.DetailsPanel />
      </Fragment>
    );
  }

  // panel

  DetailsPanel = (props: any) => {
    return (
      <div>
        <Panel
          customWidth="400px"
          headerText={'testing 7zip'}
          isBlocking={false}
          isOpen={this.state.showPanel}
          onDismiss={this.hidePanel}
          type={PanelType.customNear}
        >
          <div>
            abc<br />
            abc<br />
            abc<br />
            abc<br />
            abc<br />
            abc<br />
            {/* { this.state.showPanel &&
              <Fragment>
                <h2 className="title is-4">{ this.state.showPanel.type === 'users' ? 'Users' : 'Devices' }</h2>

                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>EGMS\EVGUKSDEVWIN001</td>
                      <td>Virtual Machine</td>
                    </tr>
                    <tr>
                      <td>EGMS\EVGUKSDEVWIN002</td>
                      <td>Virtual Machine</td>
                    </tr>
                    <tr>
                      <td>EGMS\EVGUKSDEVWIN004</td>
                      <td>Virtual Machine</td>
                    </tr>
                    <tr>
                      <td>EGMS\EVGUKSDEVWIN005</td>
                      <td>Virtual Machine</td>
                    </tr>
                    <tr>
                      <td>EGMS\EVGUKSDEVWIN006</td>
                      <td>Virtual Machine</td>
                    </tr>
                  </tbody>
                </table>
              </Fragment>
            } */}
          </div>
        </Panel>
      </div>
    );
  }

  showPanel = (event: any, type: string) => {
    this.setState({
      showPanel: {
        type: type
      }
    });
  }

  hidePanel = (event: any) => {
    this.setState({
      showPanel: null
    });
  }
}
